module.exports = __webpack_public_path__ + "static/media/Politoed_gaussian2.46b48588.png";